module.exports = __webpack_public_path__ + "img/member-more.28aa625c.svg";